<template>
  <div class="password">
    <div class="section-title">
      <span>Dados de acesso</span>
      <div v-if="loggedUser">
        <reset-password @updated="snackbarPassword = true" />
      </div>
    </div>
    <v-container v-if="!loggedUser" class="pb-0 px-0">
      <v-row no-gutters>
        <v-col>
          <v-text-field
            v-model="password"
            v-validate.disable="validator"
            outlined
            :type="showPassword ? 'text' : 'password'"
            :class="['col-100', (errors.first(field) || error) && 'block']"
            :label="label"
            :placeholder="placeholder"
            :error-messages="errors.first(field) || error"
            :name="field"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            @blur="validateField"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-text-field
            v-model="confirm"
            v-validate.disable="validator"
            outlined
            :type="showConfirm ? 'text' : 'password'"
            :class="['col-100', (errors.first(field) || error) && 'block']"
            label="Confirme sua senha"
            :placeholder="placeholder"
            :error-messages="errors.first(field) || error"
            :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showConfirm = !showConfirm"
            @blur="validateField"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbarPassword" left>
      Senha alterada com sucesso!
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarPassword = false">
          fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { screenTypeMixin } from '@/mixins/screen-type'
export default {
  name: 'FormPassword',
  inject: ['$validator'],
  components: {
    ResetPassword: () => import('@/components/modals/ResetPassword.vue')
  },
  mixins: [screenTypeMixin],
  props: {
    id: String,
    label: String,
    width: {
      type: Number,
      default: 100
    },
    field: String,
    validator: Object,
    backend: {
      type: Array,
      default: () => []
    },
    mask: {
      default: null,
      type: Array
    },
    placeholder: {
      default: null,
      type: String
    },
    extra_data: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null,
    password: '',
    confirm: '',
    validId: false,
    showPassword: false,
    showConfirm: false,
    passwordDialog: false,
    snackbarPassword: false
  }),
  computed: {
    componentValue() {
      const obj = { [this.field]: this.password }
      return this.extra_data ? { extra_data: obj } : obj
    },
    loggedUser() {
      return this.$store.getters.TOKEN
    }
  },
  methods: {
    validatePassword() {
      // note: this is called at CadastroPadrao.vue
      if (this.confirm !== this.password) {
        this.error = 'As senhas não são iguais'
        return false
      }
      this.error = ''
      return true
    },
    validateField() {
      this.$validator.validate(this.field, this.value).then(valid => {
        if (valid) {
          if (this.backend !== null && this.backend.length > 0) {
            this.backend.map(method => {
              if (this.value.length > 0) this[method](this.value)
              this.validId = false
            })
          }
          if (!this.confirm) return
          if (this.confirm !== this.password) {
            this.error = 'As senhas não são iguais'
          } else {
            this.error = ''
          }
        } else {
          this.validId = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$desktop: 1024px;

.password {
  span {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 26px;
  }
}
</style>
